import { forwardRef } from 'react';

type Props = React.SVGAttributes<SVGSVGElement>;
type Ref = SVGSVGElement;

const User = forwardRef<Ref, Props>((props, ref) => (
    <svg
        width='18'
        height='17'
        viewBox='0 0 18 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
        ref={ref}
    >
        <circle cx='7.5' cy='7.5' r='7.1' stroke='#23B3E5' strokeWidth='0.8' />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2.0376 12.6392C2.43842 10.7818 3.76258 9.26783 5.50579 8.60168C6.002 8.95734 6.61018 9.16671 7.26726 9.16671C7.99016 9.16671 8.65386 8.9133 9.1744 8.49048C11.0745 9.0864 12.5376 10.6697 12.9626 12.6393C11.5947 14.0926 9.6534 15 7.50012 15C5.34681 15 3.40545 14.0926 2.0376 12.6392Z'
            fill='#23B3E5'
        />
        <ellipse cx='7.27951' cy='5.29417' rx='2.86765' ry='3.08824' fill='#23B3E5' />
    </svg>
));

export default User;
